export const SORT_ORDER = {
  ASCENDING: "asc",
  DESCENDING: "desc",
}

export const SNACKBAR_TYPES = {
  SUCCESS: 1,
  WARNING: 2,
  INFORMATION: 3,
  ERROR: 4,
}

export const RESPONSE_CODE = {
  SUCCESS: 200,
  CREATE_SUCCESS: 201,
  TOKEN_EXPIRED: 498,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_APPROVED: 406,
  CONFLICT: 409,
}

export const STORAGE_KEY = {
  MASTER_DATA: "master_data",
  TOKEN: "token",
  LOGIN: "login",
  USER_TYPE: "type",
  TOAST: "toast",
  EMAIL: "email",
  NAME: "name",
}

export const MENU = {
  HOME: 1,
  SEND_HISTORY: 2,
  CONTACT_MEMO: 3,
  CUSTOMER_MANAGEMENT: 11,
  CUSTOMER_LIST: 12,
  CUSTOMER_REGISTER: 13,
  APPLICATION_MANAGEMENT: 71,
  APPLICATION_REGISTER: 72,
  GROUP_LIST: 14,
  GROUP_REGISTER: 15,
  TOUR_MANAGEMENT: 21,
  TOUR_LIST: 22,
  TOUR_REGISGER: 23,
  CLUB_LIST: 24,
  CLUB_REGISTER: 25,
  BUS_MANAGEMENT: 31,
  BUS_LIST: 32,
  BUS_REGISTER: 33,
  BUS_STATION_LIST: 34,
  SEAT_MANAGEMENT: 41,
  SEAT_LIST: 42,
  SEAT_REGISTER: 43,
  CSV_EXPORT: 51,
  SETTING: 61,
  ADMIN_INFO: 62,
}

export const TOUR_CLUB = {
  TOUR: "TOUR",
  CLUB: "CLUB",
}

export const TOUR_TYPE = {
  DAY: "DAY",
  STAY: "STAY",
}

export const Genders = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
} as const

export type Gender = (typeof Genders)[keyof typeof Genders]

export const GenderLabels: { [key in Gender]: string } = {
  MALE: "男性",
  FEMALE: "女性",
  OTHER: "その他",
}

export const TOUR_CLUB_TYPE = {
  TOUR: "TOUR",
  CLUB: "CLUB",
}

export const ATTENDANCE = {
  NONE: "NONE",
  ABSENT: "ABSENT",
  ATTENDANCE: "ATTENDANCE",
}

export const BUS_SEAT_REQUEST = {
  FRONT: "FRONT",
  BACK: "BACK",
  NONE: "NONE",
}

export const PROVINCES = [
  {
    name: "北海道",
    value: "北海道",
  },
  {
    name: "青森県",
    value: "青森県",
  },
  {
    name: "岩手県",
    value: "岩手県",
  },
  {
    name: "宮城県",
    value: "宮城県",
  },
  {
    name: "秋田県",
    value: "秋田県",
  },
  {
    name: "山形県",
    value: "山形県",
  },
  {
    name: "福島県",
    value: "福島県",
  },
  {
    name: "茨城県",
    value: "茨城県",
  },
  {
    name: "栃木県",
    value: "栃木県",
  },
  {
    name: "群馬県",
    value: "群馬県",
  },
  {
    name: "埼玉県",
    value: "埼玉県",
  },
  {
    name: "千葉県",
    value: "千葉県",
  },
  {
    name: "東京都",
    value: "東京都",
  },
  {
    name: "神奈川県",
    value: "神奈川県",
  },
  {
    name: "新潟県",
    value: "新潟県",
  },
  {
    name: "富山県",
    value: "富山県",
  },
  {
    name: "石川県",
    value: "石川県",
  },
  {
    name: "福井県",
    value: "福井県",
  },
  {
    name: "山梨県",
    value: "山梨県",
  },
  {
    name: "長野県",
    value: "長野県",
  },
  {
    name: "岐阜県",
    value: "岐阜県",
  },
  {
    name: "静岡県",
    value: "静岡県",
  },
  {
    name: "愛知県",
    value: "愛知県",
  },
  {
    name: "三重県",
    value: "三重県",
  },
  {
    name: "滋賀県",
    value: "滋賀県",
  },
  {
    name: "京都府",
    value: "京都府",
  },
  {
    name: "大阪府",
    value: "大阪府",
  },
  {
    name: "兵庫県",
    value: "兵庫県",
  },
  {
    name: "奈良県",
    value: "奈良県",
  },
  {
    name: "和歌山県",
    value: "和歌山県",
  },
  {
    name: "鳥取県",
    value: "鳥取県",
  },
  {
    name: "島根県",
    value: "島根県",
  },
  {
    name: "岡山県",
    value: "岡山県",
  },
  {
    name: "広島県",
    value: "広島県",
  },
  {
    name: "山口県",
    value: "山口県",
  },
  {
    name: "徳島県",
    value: "徳島県",
  },
  {
    name: "香川県",
    value: "香川県",
  },
  {
    name: "愛媛県",
    value: "愛媛県",
  },
  {
    name: "高知県",
    value: "高知県",
  },
  {
    name: "福岡県",
    value: "福岡県",
  },
  {
    name: "佐賀県",
    value: "佐賀県",
  },
  {
    name: "長崎県",
    value: "長崎県",
  },
  {
    name: "熊本県",
    value: "熊本県",
  },
  {
    name: "大分県",
    value: "大分県",
  },
  {
    name: "宮崎県",
    value: "宮崎県",
  },
  {
    name: "鹿児島県",
    value: "鹿児島県",
  },
  {
    name: "沖縄県",
    value: "沖縄県",
  },
]

export const SIDE_MENU = {
  COMPANY_LIST: 1,
  COMPANY_ADD: 2,
  EMPLOYEE_LIST: 3,
  EMPLOYEE_ADD: 4,
  TAG_LIST: 5,
  COMPANY_INFO: 6,
  PASSWORD_CHANGE: 7,
  MY_PAGE: 8,
}

export const EmploymentTypes = {
  REGULAR: "REGULAR",
  PART: "PART",
  SIDE: "SIDE",
  TEMPORARY: "TEMPORARY",
  BUSINESS: "BUSINESS",
  OTHER: "OTHER",
} as const

export type EmploymentType = (typeof EmploymentTypes)[keyof typeof EmploymentTypes]

export const EmploymentTypeLabels: Record<EmploymentType, string> = {
  REGULAR: "正社員",
  PART: "パート",
  SIDE: "アルバイト",
  TEMPORARY: "派遣社員",
  BUSINESS: "個人事業主",
  OTHER: "その他",
}

export const EMPLOYMENT_TYPE = [
  {
    name: "正社員",
    value: "REGULAR",
  },
  {
    name: "パート",
    value: "PART",
  },
  {
    name: "アルバイト",
    value: "SIDE",
  },
  {
    name: "派遣社員",
    value: "TEMPORARY",
  },
  {
    name: "個人事業主",
    value: "BUSINESS",
  },
  {
    name: "その他",
    value: "OTHER",
  },
]

export const EMPLOYMENT_TYPE_MULTI = [
  {
    label: "正社員",
    value: "REGULAR",
  },
  {
    label: "パート",
    value: "PART",
  },
  {
    label: "アルバイト",
    value: "SIDE",
  },
  {
    label: "派遣社員",
    value: "TEMPORARY",
  },
  {
    label: "個人事業主",
    value: "BUSINESS",
  },
  {
    label: "その他",
    value: "OTHER",
  },
]

export const USER_TYPES = [
  {
    name: "管理者",
    value: "ADMIN",
  },
  {
    name: "グループ管理者",
    value: "GROUPADMIN",
  },
  {
    name: "一般ユーザー",
    value: "EMPLOYEE",
  },
]

export const STATUS = {
  OFFICE: "OFFICE",
  RESIGNED: "RESIGNED",
}

export const FILTER_VALUES = {
  NAME: "NAME",
  TAG: "TAG",
  YEAR: "YEAR",
  TYPE: "TYPE",
  ID: "ID",
  STATUS: "STATUS",
  SAME: "EQUALS",
  CONTAIN: "CONTAINS",
  LARGER: "BIGGER",
  SMALLER: "SMALLER",
}

export const FILTER_OBJECTS = [
  {
    name: "氏名",
    value: FILTER_VALUES.NAME,
  },
  {
    name: "タグ",
    value: FILTER_VALUES.TAG,
  },
  {
    name: "勤務年数",
    value: FILTER_VALUES.YEAR,
  },
  {
    name: "雇用形態",
    value: FILTER_VALUES.TYPE,
  },
  {
    name: "ID",
    value: FILTER_VALUES.ID,
  },
  {
    name: "退職状態",
    value: FILTER_VALUES.STATUS,
  },
]

export const FILTER_CONDITION_ID_NAME = [
  {
    name: "が次に等しい",
    value: FILTER_VALUES.SAME,
  },
  {
    name: "が次を含む",
    value: FILTER_VALUES.CONTAIN,
  },
]

export const FILTER_CONDITION_YEAR = [
  {
    name: "が次に等しい",
    value: FILTER_VALUES.SAME,
  },
  {
    name: "が次以上",
    value: FILTER_VALUES.LARGER,
  },
  {
    name: "が次以下",
    value: FILTER_VALUES.SMALLER,
  },
]

export const FILTER_CONDITION_TAG_TYPE_STATUS = [
  {
    name: "が次に等しい",
    value: FILTER_VALUES.SAME,
  },
]

export const USER_TYPE = {
  GROUPADMIN: "GROUPADMIN",
  ADMIN: "ADMIN",
  USER: "EMPLOYEE",
}

export const EMPLOYMENT_RESIGN_STATUS = [
  {
    name: "在職中",
    value: STATUS.OFFICE,
  },
  {
    name: "退職",
    value: STATUS.RESIGNED,
  },
]

export const TRIPLE_PRODUCTS = ["MANUAL", "CONSULTING", "PAGE", "REPORT"]
